import { InjectionToken } from "@angular/core";

export const WINDOW_TOKEN = new InjectionToken<Window>("WindowToken", {
    providedIn: "root",
    factory: () => window
});
